export const useGetUrlParams = () => {
    const paramsObj = new URLSearchParams(window.location.search);
    const compParam = paramsObj.get('Competition') || paramsObj.get('comp');
    const seasonParam = paramsObj.get('Season');
    const roundParam = paramsObj.get('Round');
    const teamsParam = paramsObj.get('Teams');
    const venuesParam = paramsObj.get('Venues');
    const citiesParam = paramsObj.get('Cities');

    return {
        competition: parseInt(compParam) || '',
        season: parseInt(seasonParam) || '',
        round: parseInt(roundParam) || '',
        teams: teamsParam ? teamsParam.split(',') : [],
        venues: venuesParam ? venuesParam.split(',') : [],
        cities: citiesParam ? citiesParam.split(',') : []
    };
};
